import React from "react"

import {FieldViewGroupProps} from "../../../../render/group/@type"
import UI5Rating from "../../../../../gd-ui/rating/rating";
import FieldRating from "../../rating";

// const debug = "FieldRating_ViewGroup"
const debug = false

export default function FieldRating_ViewGroup(props: FieldViewGroupProps) {

    const field     = props.field as FieldRating
    const value     = props.field.getViewValue(props.model)

    debug && console.log(debug, 'render', value)

    const classes   = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)

    if (value && value > 0) {
        return (
            <div className={classes}>
                <UI5Rating
                    className    = {Classes('m-l-4', props.className)}
                    scale        = {field.scale}
                    value        = {props.model[props.field.fieldId]}
                />
            </div>
        )
    } else {
        return (
            <div className={classes}>
                {props.showGroupIcon !== false &&
                    <div className="flex-row-center-center flex-no-shrink size-22">
                        <div className="ui5-ico-15 i5-star-empty"/>
                    </div>
                }
                <div className="max-w-100-percent txt-truncate view-group-label">Not set</div>
            </div>
        )
    }
}



